import React from "react";
import { createRoot } from "react-dom/client";
import '@ant-design/v5-patch-for-react-19';
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./components/msalAuth/msalConfig";

// ================================================================================ //

import { Q_STORAGE_KEY } from "./config/campaigns";

(function captureCampaignCode() {
  try {
    const text = (new URLSearchParams(window.location.search).get("q") || "").trim();
    if (text) sessionStorage.setItem(Q_STORAGE_KEY, text);
  } catch (err) {}
})();

// ================================================================================ //

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

const root = createRoot(document.getElementById("root"));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
